export default function Dashboard() { return (
    <div className="admin-page-placeholder">
      <h2>Dashboard</h2>
      <p>Manage application masters from this section.</p>
    </div>
  );
}

